import React from 'react';

export interface IStorageUsageMonitor {
  updateStorageUsageForDirectory: (directory: string) => void;
}

const StorageUsageMonitorContext = React.createContext<IStorageUsageMonitor>({
  updateStorageUsageForDirectory: (directory: string) => {},
});

export default StorageUsageMonitorContext;
